/**
 * @generated SignedSource<<707ad3f1c47c9a90da4eaf229f0095a7>>
 * @relayHash dd40aeb6fc73bc273970d4ee863d8e11
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dd40aeb6fc73bc273970d4ee863d8e11

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Access = "APP" | "BOOK_DOC_AT_PARTNER" | "BOOK_DOC_AT_PHARMACY" | "INBOUND_CALL" | "OUTBOUND_CALL" | "PARTNER_PORTAL" | "WEBSITE" | "WEB_BOOKING";
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
export type AppointmentTagVariant = "ATTENTION" | "CRITICAL" | "MOST_CRITICAL" | "NEUTRAL" | "SUCCESS" | "WARNING";
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type Country = "CH" | "DE";
export type Flexibility = "FIXED_TIME" | "FLEXIBLE" | "NOT_EARLIER";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type MedgateConnectChannel = "PARTNER" | "PATIENT";
export type MedgateConnectOrderStatus = "CLOSED" | "FULFILLED" | "OPEN";
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type PreventionProgramTreatmentPlanTemplateCase = "NO_REGION_NO_ZIP" | "REGION" | "ZIP";
export type RequestType = "NONE" | "ONBOARDING_CALL" | "PLANNED_SELF_REFERRAL" | "PRESCRIPTION" | "PRESCRIPTION_ASTHMA" | "PRESCRIPTION_ATHLETES_FOOT" | "PRESCRIPTION_BLOOD_PRESSURE" | "PRESCRIPTION_CONTRACEPTIVE_PILL" | "PRESCRIPTION_ERECTILE_DYSFUNCTION" | "PRESCRIPTION_HAY_FEVER" | "PRESCRIPTION_HEARTBURN" | "PRESCRIPTION_HYPOTHYROIDISM" | "PRESCRIPTION_MIGRAINE" | "PRESCRIPTION_URINARY_TRACT_INFECTION" | "PRESCRIPTION_VAGINAL_MYCOSIS" | "REFERRAL" | "SICK_LEAVE_CERTIFICATE" | "SICK_LEAVE_FOR_LEGAL_GUARDIAN" | "SKIN_CHECK";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type Urgency = "MEDICAL_ACUTE" | "MEDICAL_URGENT" | "NORMAL";
export type CancelAppointmentInput = {
  id: string;
  shouldIncreaseMissedCall: boolean;
  willRelease: boolean;
};
export type useCancelAppointmentMutation$variables = {
  cancelAppointment: CancelAppointmentInput;
};
export type useCancelAppointmentMutation$data = {
  readonly cancelAppointment: {
    readonly appointment: {
      readonly __typename: "Appointment";
      readonly access: Access;
      readonly appointmentType: AppointmentType;
      readonly assignedTo: string | null;
      readonly billingAttribute: {
        readonly " $fragmentSpreads": FragmentRefs<"BillingAttributeFragment">;
      } | null;
      readonly channel: CommunicationChannel;
      readonly completedAt: string | null;
      readonly date: any;
      readonly delay: number;
      readonly desiredAgentGender: Gender;
      readonly fileUploadRequest: {
        readonly " $fragmentSpreads": FragmentRefs<"FileUploadRequestFragment">;
      } | null;
      readonly flexibility: Flexibility;
      readonly followUpForProgressNote: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly isCompleted: boolean;
      readonly isInvoiced: boolean;
      readonly language: Language;
      readonly medgateConnectChannel: MedgateConnectChannel | null;
      readonly medgateConnectOrder: {
        readonly createdAt: string;
        readonly orderCode: string;
        readonly status: MedgateConnectOrderStatus;
      } | null;
      readonly partnerUserEmail: string | null;
      readonly patientAddress: {
        readonly city: string;
        readonly country: {
          readonly countryIsoCode2: string;
          readonly countryLookupTranslations: ReadonlyArray<{
            readonly countryIsoCode2: string;
            readonly countryName: string;
            readonly id: string;
            readonly language: string;
          }>;
          readonly dialCode: string;
          readonly id: string;
          readonly mask: string | null;
        } | null;
        readonly countryCode: string;
        readonly houseNumberStreet: string;
        readonly postalCode: string;
      } | null;
      readonly patientPhoneNumber: string | null;
      readonly preventionProgramKeys: ReadonlyArray<string>;
      readonly reason: string;
      readonly relatedPreventionPrograms: ReadonlyArray<{
        readonly analysis: {
          readonly matchedCase: PreventionProgramTreatmentPlanTemplateCase;
          readonly pointOfCare: PointOfCareType;
          readonly treatmentPlanTemplateId: string | null;
        };
        readonly country: Country;
        readonly id: string;
        readonly key: string;
        readonly name: {
          readonly de: string;
          readonly en: string;
        };
        readonly patientId: string;
        readonly preventionProgramId: string;
      }>;
      readonly requestType: RequestType;
      readonly service: Service;
      readonly slotId: number;
      readonly specialty: ServiceSpecialty;
      readonly startingSoonNotificationSent: boolean;
      readonly status: AppointmentStatus;
      readonly tags: ReadonlyArray<{
        readonly value: string;
        readonly variant: AppointmentTagVariant;
      }>;
      readonly takenAt: string | null;
      readonly takenBy: string | null;
      readonly updatedAt: string;
      readonly updatedBy: string;
      readonly urgency: Urgency;
    } | null;
  };
};
export type useCancelAppointmentMutation = {
  response: useCancelAppointmentMutation$data;
  variables: useCancelAppointmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cancelAppointment"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "cancelAppointment"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delay",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channel",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedTo",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInvoiced",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slotId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "takenAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "access",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "service",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specialty",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urgency",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedAt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "takenBy",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appointmentType",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "desiredAgentGender",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientPhoneNumber",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startingSoonNotificationSent",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flexibility",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryIsoCode2",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "patientAddress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CountryLookup",
      "kind": "LinkedField",
      "name": "country",
      "plural": false,
      "selections": [
        (v29/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dialCode",
          "storageKey": null
        },
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mask",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CountryLookupTranslation",
          "kind": "LinkedField",
          "name": "countryLookupTranslations",
          "plural": true,
          "selections": [
            (v29/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryName",
              "storageKey": null
            },
            (v2/*:: as any*/),
            (v14/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "houseNumberStreet",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryCode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medgateConnectChannel",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partnerUserEmail",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderCode",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentTag",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "variant",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preventionProgramKeys",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preventionProgramId",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "LocalizedName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "en",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "de",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "PreventionProgramAnalysis",
  "kind": "LinkedField",
  "name": "analysis",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchedCase",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pointOfCare",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "treatmentPlanTemplateId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCancelAppointmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CancelAppointmentPayload",
        "kind": "LinkedField",
        "name": "cancelAppointment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v28/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAttribute",
                "kind": "LinkedField",
                "name": "billingAttribute",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BillingAttributeFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "followUpForProgressNote",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v30/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FileUploadRequest",
                "kind": "LinkedField",
                "name": "fileUploadRequest",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FileUploadRequestFragment"
                  }
                ],
                "storageKey": null
              },
              (v31/*:: as any*/),
              (v32/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MedgateConnectOrder",
                "kind": "LinkedField",
                "name": "medgateConnectOrder",
                "plural": false,
                "selections": [
                  (v33/*:: as any*/),
                  (v8/*:: as any*/),
                  (v34/*:: as any*/)
                ],
                "storageKey": null
              },
              (v35/*:: as any*/),
              (v36/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "relatedPreventionPrograms",
                "plural": true,
                "selections": [
                  (v37/*:: as any*/),
                  (v38/*:: as any*/),
                  (v2/*:: as any*/),
                  (v39/*:: as any*/),
                  (v40/*:: as any*/),
                  (v41/*:: as any*/),
                  (v42/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCancelAppointmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CancelAppointmentPayload",
        "kind": "LinkedField",
        "name": "cancelAppointment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v28/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAttribute",
                "kind": "LinkedField",
                "name": "billingAttribute",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isNotBillable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notBillableReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "treatmentReason",
                    "storageKey": null
                  },
                  (v7/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVisualSymptomExamination",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentGestationWeek",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organisationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateOfAccident",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accidentReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isEmployer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lawType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ivgCaseReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mvgCaseReference",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "followUpForProgressNote",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v30/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FileUploadRequest",
                "kind": "LinkedField",
                "name": "fileUploadRequest",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v34/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdBy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  (v8/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sessionCode",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v31/*:: as any*/),
              (v32/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MedgateConnectOrder",
                "kind": "LinkedField",
                "name": "medgateConnectOrder",
                "plural": false,
                "selections": [
                  (v33/*:: as any*/),
                  (v8/*:: as any*/),
                  (v34/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v35/*:: as any*/),
              (v36/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "relatedPreventionPrograms",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  (v37/*:: as any*/),
                  (v38/*:: as any*/),
                  (v2/*:: as any*/),
                  (v39/*:: as any*/),
                  (v40/*:: as any*/),
                  (v41/*:: as any*/),
                  (v42/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "dd40aeb6fc73bc273970d4ee863d8e11",
    "metadata": {},
    "name": "useCancelAppointmentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "759925ffdfdfc564f43fcdbf7a5ecca5";

export default node;
